// English for the catalog area. Key: exact Macedonian text passed to t().
const en = {
  // Shared catalog labels / list chrome
  'Назив': 'Name',
  'Назив *': 'Name *',
  'Опис': 'Description',
  'Данок': 'Tax',
  'ДДВ': 'VAT',
  'Акции': 'Actions',
  'Код': 'Code',
  'Тип': 'Type',
  'Локација': 'Location',
  'Адреса': 'Address',
  'Телефон': 'Phone',
  'Е-пошта': 'Email',
  'Веб-страница': 'Website',
  'Веб-страна': 'Website',
  'Креирано на': 'Created on',
  'Креирана на': 'Created on',
  'Почетна': 'Home',
  'Успешно': 'Success',
  'Зачувано': 'Saved',
  'Грешка: {message}': 'Error: {message}',
  'Се брише...': 'Deleting...',
  'Се зачувува...': 'Saving...',
  'Избери колони': 'Choose columns',
  'Колони': 'Columns',
  'Прикажи колони': 'Show columns',
  'Освежи ја листата': 'Refresh the list',
  'Освежи': 'Refresh',
  'Експорт': 'Export',
  'Импорт': 'Import',
  'Основни податоци': 'Basic information',
  'Сокриј дополнителни полиња': 'Hide additional fields',
  'Прикажи дополнителни полиња': 'Show additional fields',
  'Пополнете ги сите задолжителни полиња.': 'Please fill in all required fields.',
  'Дали сте сигурни дека сакате да го избришете „{name}“?': 'Are you sure you want to delete “{name}”?',
  'Дали сте сигурни дека сакате да ја избришете „{name}“?': 'Are you sure you want to delete “{name}”?',

  // Products
  'Продукти': 'Products',
  'Категорија': 'Category',
  'Производител': 'Manufacturer',
  'Набавна цена': 'Cost price',
  'Единечна цена': 'Unit price',
  'Продажна цена': 'Selling price',
  'Попуст': 'Discount',
  'Попуст %': 'Discount %',
  'Увезен: Да': 'Imported: Yes',
  'Увезен: Не': 'Imported: No',
  'Продуктот не е избришан': 'The product was not deleted',
  'Продуктот е избришан.': 'The product was deleted.',
  'Вчитување на продукти...': 'Loading products...',
  'Назив, тип, опис или локација...': 'Name, type, description or location...',
  'Сите категории': 'All categories',
  'Сите производители': 'All manufacturers',
  'Избриши ги филтрите': 'Clear filters',
  'Нов продукт': 'New product',
  'Нов Продукт': 'New Product',
  'Нов производ': 'New product',
  'Импортирај продукти': 'Import products',
  'Експортирај ги продуктите во CSV': 'Export products to CSV',
  'Нема пронајдени продукти': 'No products found',
  'Измени производ': 'Edit product',
  'Уреди производ': 'Edit product',
  'Избриши продукт': 'Delete product',
  'Шифрата е копирана!': 'Code copied!',
  'Неуспешно копирање на шифрата': 'Failed to copy the code',
  'Неуспешно вчитување на категории': 'Failed to load categories',
  'Неуспешно вчитување на производители': 'Failed to load manufacturers',
  'Производот не може да се вчита': 'The product could not be loaded',
  'Неуспешно вчитување на производот': 'Failed to load the product',
  'Производот не може да се ажурира': 'The product could not be updated',
  'Производот не може да се креира': 'The product could not be created',
  'Кликнете за копирање': 'Click to copy',
  'Овој производ е увезен': 'This product was imported',
  'Овој производ е внесен рачно': 'This product was entered manually',
  'Назив на производ': 'Product name',
  'Внесете назив': 'Enter a name',
  'Единица мерка': 'Unit of measure',
  'пар': 'pair',
  'Изберете категорија': 'Select a category',
  'Изберете производител': 'Select a manufacturer',
  'Тип на производ': 'Product type',
  'Локација во магацин': 'Warehouse location',
  'Опис на производот...': 'Product description...',
  'Креирај производ': 'Create product',

  // Product import
  'Листа на производи': 'Product list',
  'Ред': 'Row',
  'Единица': 'Unit',
  'Валиден': 'Valid',
  'Вчитани {count} редови': 'Loaded {count} rows',
  'Грешка при читање на датотеката. Проверете го форматот.': 'Error reading the file. Check the format.',
  'Називот е задолжителен': 'Name is required',
  'Цената мора да биде број': 'Price must be a number',
  'Набавната цена мора да биде број': 'Cost price must be a number',
  'ДДВ мора да биде број помеѓу 0 и 100': 'VAT must be a number between 0 and 100',
  'Нема податоци за увоз': 'No data to import',
  'Нема валидни редови за увоз': 'No valid rows to import',
  'Успешно увезени {count} производи': 'Successfully imported {count} products',
  '{count} редови имаа грешки.': '{count} rows had errors.',
  'Увозот не успеа: {message}': 'Import failed: {message}',
  'Увозот не успеа. Обидете се повторно.': 'Import failed. Please try again.',
  'Увоз на производи': 'Import products',
  'Кликнете за прикачување': 'Click to upload',
  'или повлечете и пуштете': 'or drag and drop',
  'CSV или Excel датотеки (XLS, XLSX)': 'CSV or Excel files (XLS, XLSX)',
  'Преземи шаблон': 'Download template',
  'Преглед на податоци': 'Data preview',
  'Исчисти': 'Clear',
  'Се увезува...': 'Importing...',
  'Увези {count} производи': 'Import {count} products',
  'Нема податоци за преглед': 'No data to preview',
  'Упатство за увоз:': 'Import instructions:',
  'Прикачете CSV или Excel датотека со податоци за производи': 'Upload a CSV or Excel file with product data',
  'Задолжителни колони: name': 'Required columns: name',
  'Опционални колони: cost_price, tax, unit, manufacturer, category': 'Optional columns: cost_price, tax, unit, manufacturer, category',
  'Преземете го шаблонот за правилен формат': 'Download the template for the correct format',
  'Прегледајте ги податоците пред увоз': 'Review the data before importing',
  'Ќе се увезат само валидните редови': 'Only valid rows will be imported',

  // Partners
  'Партнери': 'Partners',
  'Матичен број': 'Company ID',
  'Даночен број': 'Tax number',
  'Банка': 'Bank',
  'Банкарска сметка': 'Bank account',
  'Жиро сметка': 'Bank account',
  'Овластено лице': 'Authorized person',
  'Дополнителен контакт': 'Additional contact',
  'Прв контакт': 'Primary contact',
  'Втор контакт': 'Secondary contact',
  'Партнерот не е избришан': 'The partner was not deleted',
  'Партнерот е избришан.': 'The partner was deleted.',
  'Вчитување на партнери...': 'Loading partners...',
  'Назив, адреса, телефон или е-пошта...': 'Name, address, phone or email...',
  'Избриши го филтерот': 'Clear filter',
  'Нов партнер': 'New partner',
  'Нов Партнер': 'New Partner',
  'Експортирај ги партнерите во CSV': 'Export partners to CSV',
  'Нема пронајдени партнери': 'No partners found',
  'Измени партнер': 'Edit partner',
  'Уреди партнер': 'Edit partner',
  'Избриши партнер': 'Delete partner',
  'Партнерот не може да се вчита': 'The partner could not be loaded',
  'Неуспешно вчитување на партнерот': 'Failed to load the partner',
  'Партнерот не може да се ажурира': 'The partner could not be updated',
  'Партнерот не може да се креира': 'The partner could not be created',
  'Назив на партнер': 'Partner name',
  'Креирај партнер': 'Create partner',
  'Преглед на партнери': 'View partners',
  'Листа на сите партнери.': 'List of all partners.',
  'Додади партнер': 'Add partner',
  'Додадете нов партнер.': 'Add a new partner.',

  // Manufacturers
  'Производители': 'Manufacturers',
  'Производителот не е избришан': 'The manufacturer was not deleted',
  'Производителот е избришан.': 'The manufacturer was deleted.',
  'Вчитување на производители...': 'Loading manufacturers...',
  'Нов производител': 'New manufacturer',
  'Нов Производител': 'New Manufacturer',
  'Експортирај ги производителите во CSV': 'Export manufacturers to CSV',
  'Нема пронајдени производители': 'No manufacturers found',
  'Измени производител': 'Edit manufacturer',
  'Избриши производител': 'Delete manufacturer',
  'Производителот не може да се вчита': 'The manufacturer could not be loaded',
  'Неуспешно вчитување на производителот.': 'Failed to load the manufacturer.',
  'Производителот не може да се ажурира': 'The manufacturer could not be updated',
  'Производителот не може да се додаде': 'The manufacturer could not be added',
  'Додади производител': 'Add manufacturer',

  // Categories
  'Категории': 'Categories',
  'Категоријата не е избришана': 'The category was not deleted',
  'Категоријата е избришана.': 'The category was deleted.',
  'Вчитување на категории...': 'Loading categories...',
  'Нова категорија': 'New category',
  'Нова Категорија': 'New Category',
  'Нема пронајдени категории': 'No categories found',
  'Измени категорија': 'Edit category',
  'Уреди категорија': 'Edit category',
  'Избриши категорија': 'Delete category',
  'Категоријата не може да се вчита': 'The category could not be loaded',
  'Неуспешно вчитување на категоријата.': 'Failed to load the category.',
  'Недостасува име': 'Name missing',
  'Името на категоријата е задолжително.': 'The category name is required.',
  'Категоријата не може да се ажурира': 'The category could not be updated',
  'Категоријата не може да се креира': 'The category could not be created',
  'Не е дефиниран': 'Not defined',
  'Категоријата е успешно креирана.': 'The category was created successfully.',
  'Креирај категорија': 'Create category',
};

export default en;
